<template>
  <div class="date-range">
    <div :class="{'enabled': !disabled}" class="date-range__quick-dates">
      <b-button v-for="year in lastYears"
                :key="year"
                @click="setYearRange(year)"
                variant="primary" size="sm" class="date-button">
        {{ year }}
      </b-button>

      <b-button @click="setYearToDateRange" variant="primary" size="sm" class="date-button">YTD</b-button>
      <b-button @click="setQuarterToDateRange" variant="primary" size="sm" class="date-button">QTD</b-button>
    </div>

    <div class="date-range__inputs">
      <b-form-input type="date"
                    class="datepicker mr-2 bg-dark"
                    v-model="internalStartDate"
                    @input="handleStartDateUpdated"
                    :disabled="disabled" />

      <b-form-input type="date"
                    class="datepicker mr-2 bg-dark"
                    v-model="internalEndDate"
                    @input="handleEndDateUpdated"
                    :disabled="disabled" />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { getCurrentYear } from '@/shared/date-utils'

export default {
  name: 'date-range',
  props: {
    startDate: {
      type: String,
      default: () => moment('2017-01-01').format('YYYY-MM-DD')
    },
    endDate: {
      type: String,
      default: () => moment().format('YYYY-MM-DD'),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalStartDate: this.startDate,
      internalEndDate: this.endDate,

      lastYears: this.getLastYears(),
    };
  },
  methods: {
    applyFilter() {
      this.$emit('update:startDate', this.internalStartDate);
      this.$emit('update:endDate', this.internalEndDate);
      this.$emit('input');
    },

    handleStartDateUpdated() {
      this.$emit('update:startDate', this.internalStartDate);
      this.$emit('input');
    },

    handleEndDateUpdated() {
      this.$emit('update:endDate', this.internalEndDate);
      this.$emit('input');
    },

    getLastYears() {
      const lastYearsCount = 3;
      const startYear = getCurrentYear() - lastYearsCount;

      return new Array(lastYearsCount).fill('').map(
        (item, index) => startYear + index
      );
    },

    getCurrentYear() {
      return new Date().getFullYear();
    },

    setYearRange(year) {
      this.internalStartDate = `${year}-01-01`;
      this.internalEndDate = `${year}-12-31`;
      this.applyFilter()
    },

    setYearToDateRange() {
      const currentYear = getCurrentYear();
      this.internalStartDate = `${currentYear}-01-01`;
      this.internalEndDate = moment().format('YYYY-MM-DD');
      this.applyFilter()
    },

    setQuarterToDateRange() {
      const currentYear = getCurrentYear();
      const currentQuarter = moment().quarter();
      let startMonth = ((currentQuarter - 1) * 3) + 1;
      startMonth = `0${startMonth}`.slice(-2);  // 01, 02, .. 12

      this.internalStartDate = moment(`${currentYear}-${startMonth}-01`).format('YYYY-MM-DD');
      this.internalEndDate = moment().format('YYYY-MM-DD');
      this.applyFilter()
    },
  },

  watch: {
    startDate: function (value) {
      if(this.internalStartDate !== value) {
        this.internalStartDate = value;
      }
    },
    endDate: function (value) {
      if(this.internalEndDate !== value) {
        this.internalEndDate = value;
      }
    },
  },
}
</script>

<style scoped lang="scss">
  .date-range {
    position: relative;

    &__quick-dates {
      position: absolute;
      left: 0;
      top: -30px;
      padding-bottom: 8px;
      width: 100%;

      visibility: hidden;
      opacity: 0;
      z-index: 1030;

      display: flex;
      justify-content: space-around;
      align-items: center;

      .date-button:not(:last-child) {
        margin-right: 0.2rem;
      }
    }

    &__inputs {
      display: flex;
      align-items: center;
    }

    &:hover &__quick-dates.enabled {
      visibility: visible;
      opacity: 1;
      transition: opacity 0.5s;
    }
  }

</style>
